import styled from '@emotion/styled'

export default styled.h4`
 color: green;
 font-size: .9rem;
`
